import React from 'react';
import { BudgetHistory } from '../../../types';
import BudgetHistoryTable from './BudgetHistoryTable';

import { BudgetRecipientEnum } from '../../../createAndEdit/types';
import { Budget } from '../../../types';

interface IBudgetHistorySectionProps {
  history: BudgetHistory[];
  isLoading: boolean;
  budgetId: string;
  onViewBudget: (budgetId: string, versionNumber?: number) => void;
  onEditBudget?: (budgetId: string, versionNumber?: number) => void;
  budget?: Budget;
  userProfile?: BudgetRecipientEnum | string;
}

const BudgetHistorySection = (props: IBudgetHistorySectionProps) => {
  let content: React.ReactNode;

  if (props.isLoading) {
    content = <div className="text-center py-4 text-gray-500">Carregando histórico...</div>;
  } else if (props.history.length > 0) {
    content = (
      <BudgetHistoryTable
        history={props.history}
        budgetId={props.budgetId}
        onViewBudget={props.onViewBudget}
        onEditBudget={props.onEditBudget}
        budget={props.budget}
        userProfile={props.userProfile}
      />
    );
  } else {
    content = <div className="text-center py-4 text-gray-500">Nenhum histórico encontrado</div>;
  }

  return (
    <div className="p-4 bg-gray-50">
      <div className="text-size-14 text-color-gray mb-4">Histórico de alterações:</div>
      {content}
    </div>
  );
};

export default BudgetHistorySection;
